import React from 'react';
import {
  Row, Col, Card, CardHeader, CardBody, Button, Alert,
} from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import listAdministratif, { listAnnexesEstate } from './list_administratif';
import { getLabelFromType } from '../../../utils/functions';
import ModalAdd from './ModalAdd';

const idLocale = require('moment/locale/fr');

moment.locale('fr', idLocale);

class Administratif extends React.Component {
  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    handleSubmit: PropTypes.func,
    deleteLinkedInfo: PropTypes.func,
    isViewOnly: PropTypes.bool,
    setDocument: PropTypes.func.isRequired,
  };

  static defaultProps = {
    handleSubmit: () => {},
    deleteLinkedInfo: () => {},
    isViewOnly: false,
  };

  constructor() {
    super();
    this.state = {
      isModal: false,
      category: '',
      itemInfo: {},
      assetData: {},
    };
  }

  toggleModal = (category, itemInfo, assetData = {}) => {
    this.setState(prevState => ({
      category,
      itemInfo,
      assetData,
      isModal: !prevState.isModal,
    }));
  }

  checkBeforeSubmit = (dataForm) => {
    console.log('dataForm is: ', dataForm);
    const { handleSubmit } = this.props;
    handleSubmit(dataForm);
  }

  deletePlanner = (data) => {
    console.log(data);
    const { deleteLinkedInfo } = this.props;
    this.toggleModal();
    deleteLinkedInfo(data);
  }

  updateList = () => {
    const { data } = this.props;
    const { category } = data;
    let { linked_info } = data;
    if (!linked_info) linked_info = [];
    const newList = category === 'company' ? [...listAdministratif] : [...listAnnexesEstate];
    newList.forEach((item) => {
      item.listing.forEach((subitem, index, newItem) => {
        const myAssets = linked_info.filter(x => x.subcategory === subitem.img);
        delete newItem[index].myAssets;
        if (myAssets.length > 0) {
          newItem[index].myAssets = myAssets;
        }
      });
    });
    return newList;
  }

  render() {
    const {
      isModal, category, itemInfo, assetData,
    } = this.state;
    const { data, isViewOnly, setDocument } = this.props;
    const {
      category: assetcategory, list_assets = [], _id,
    } = data;
    const updatedList = this.updateList();
    return (
      <div>
        {
          !isViewOnly && (
            <Alert color="info">
              {assetcategory === 'company' ? 'La vie quotidienne d\'une entreprise' : 'La gestion d\'un bien immobilier'} repose sur une quantité d'information qui peut s'avérer complexe et éparse.<br />Cette section a été conçue afin d'en faciliter la reprise par votre destinataire de l'information en centralisant les informations administratives qui lui seront délivrées le moment venu.
            </Alert>
          )
        }
        {
          (isViewOnly && list_assets.filter(e => e._id === _id && e.linked_info.length > 0).length === 0) ? (
            <div>
              Aucune information ajoutée.
            </div>
          ) : (
            <Row>
              {
                updatedList.map(item => (
                  <Col lg="6" xl="4" key={item.title} className="planner-col-wrapper">
                    <Card className="light-border">
                      <CardHeader className="white-background fs16">
                        <div className="planner-title">{item.title}</div>
                      </CardHeader>
                      <CardBody>
                        <div className="planner-list">
                          {item.listing.map((subitem) => {
                            if (subitem.myAssets) {
                              return (
                                <div key={subitem.title} className="planner-content">
                                  <div className="planner-header">
                                    <div className="logo">
                                      <img src={`${process.env.PUBLIC_URL}/img/${subitem.img}.svg`} alt="logo_img" />
                                    </div>
                                    <div className="planner-description">
                                      {subitem.title}
                                      {!isViewOnly && <Button onClick={() => this.toggleModal(item.category, subitem)} className="semiBold planner-test-add" size="sm" color="official">Ajouter</Button>}
                                    </div>
                                  </div>
                                  {subitem.myAssets.map(asset => (
                                    <div key={asset._id} className="planner-item">
                                      <Button onClick={() => this.toggleModal(item.category, subitem, asset)} color="link" className="blueish">
                                        {asset.title || `${subitem.title}`}
                                      </Button>
                                      {asset.type && <p>{getLabelFromType(asset.subcategory, asset.type)}</p>}
                                      {asset.credential && <p>{asset.credential}</p>}
                                      <span className={asset.credential && 'bringTop'}>
                                        {moment(asset.created_at).format('L')}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            return (
                              <Button disabled={isViewOnly} key={subitem.title} onClick={() => this.toggleModal(item.category, subitem)} className="planner-btn">
                                <div className="logo">
                                  <img src={`${process.env.PUBLIC_URL}/img/${subitem.img}.svg`} alt="logo_img" />
                                </div>
                                <div className="planner-description">
                                  {subitem.title}
                                </div>
                              </Button>
                            );
                          })}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))
              }
            </Row>
          )
        }
        {
          isModal && (
            <ModalAdd
              isViewing={isViewOnly}
              isViewOnly={isViewOnly}
              isEditing={!isViewOnly}
              handleSubmit={this.checkBeforeSubmit}
              isModal={isModal}
              itemInfo={itemInfo}
              toggle={this.toggleModal}
              category={category}
              deletePlanner={this.deletePlanner}
              assetData={assetData}
              isFromAssetDetails={!isViewOnly}
              setDocument={setDocument}
            />
          )
        }
      </div>
    );
  }
}

export default Administratif;
